var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Not_Received"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_Received",
    "data-name": "Not Received",
    clipPath: "url(#clip-Not_Received)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36036",
    "data-name": "Group 36036",
    transform: "translate(-9479.729 -14156.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29779",
    "data-name": "Group 29779",
    transform: "translate(9480.479 14157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15718",
    "data-name": "Rectangle 15718",
    width: 10.5,
    height: 10.5,
    rx: 4,
    fill: "rgba(255,0,0,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15718_-_Outline",
    "data-name": "Rectangle 15718 - Outline",
    d: "M2.625.656A1.971,1.971,0,0,0,.656,2.625v5.25A1.971,1.971,0,0,0,2.625,9.844h5.25A1.971,1.971,0,0,0,9.844,7.875V2.625A1.971,1.971,0,0,0,7.875.656H2.625m0-.656h5.25A2.625,2.625,0,0,1,10.5,2.625v5.25A2.625,2.625,0,0,1,7.875,10.5H2.625A2.625,2.625,0,0,1,0,7.875V2.625A2.625,2.625,0,0,1,2.625,0Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(3.281 3.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36784",
    "data-name": "Path 36784",
    d: "M7.667,7.686a.359.359,0,0,0,0-.507L6.2,5.691,4.374,3.842a.358.358,0,1,0-.51.5l3.3,3.337a.358.358,0,0,0,.507,0Zm-3.315-.02,3.335-3.3a.358.358,0,0,0-.5-.51l-3.335,3.3A.359.359,0,0,0,4.1,7.77a.355.355,0,0,0,.252-.1Z",
    transform: "translate(-3.741 -3.736)",
    fill: "red"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotReceived);
export default __webpack_public_path__ + "static/media/Icon_NotReceived.6809da6fd9205ac92e5deb81936c469a.svg";
export { ForwardRef as ReactComponent };